import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="h-14 overflow-hidden flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_nettoyage-rdv/artifacts/sr58gnln_Screenshot_2025-11-19-09-02-07-924_com.miui.gallery.jpg" 
                alt="BA NETTOYAGE" 
                className="h-[220%] w-auto object-cover object-center bg-white rounded-lg"
                style={{ marginTop: '-30%', marginBottom: '-30%' }}
              />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Services de nettoyage automobile à domicile et nettoyage d'intérieur professionnels en Auvergne.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-['Outfit'] font-semibold text-white mb-4">Services</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-slate-400 hover:text-sky-400 transition-colors text-sm">
                  Nettoyage Auto Extérieur
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-sky-400 transition-colors text-sm">
                  Nettoyage Auto Intérieur
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-sky-400 transition-colors text-sm">
                  Nettoyage Vitres
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-sky-400 transition-colors text-sm">
                  Nettoyage Canapé & Fauteuils
                </Link>
              </li>
            </ul>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-['Outfit'] font-semibold text-white mb-4">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-slate-400 hover:text-sky-400 transition-colors text-sm">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-sky-400 transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-slate-400 hover:text-sky-400 transition-colors text-sm">
                  Réserver
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-sky-400 transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-['Outfit'] font-semibold text-white mb-4">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-sky-500 flex-shrink-0" />
                <a href="tel:0769119183" className="text-slate-400 hover:text-sky-400 transition-colors text-sm">
                  07 69 11 91 83
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-sky-500 flex-shrink-0" />
                <a href="mailto:burhan.arslan@laposte.net" className="text-slate-400 hover:text-sky-400 transition-colors text-sm break-all">
                  burhan.arslan@laposte.net
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-sky-500 flex-shrink-0 mt-0.5" />
                <span className="text-slate-400 text-sm">
                  63600 Ambert<br />Auvergne-Rhône-Alpes
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} BA NETTOYAGE. Tous droits réservés.
          </p>
          <div className="flex items-center gap-6">
            <span className="trust-badge !bg-slate-800 !text-slate-300">
              Service à domicile
            </span>
            <span className="trust-badge !bg-slate-800 !text-slate-300">
              Devis gratuit
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};
